import * as yup from 'yup';

export const formSchema = yup.object({
    price: yup.mixed().required(),
    subject: yup.string().min(1).required(),
});